'use client'

import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Activity } from 'lucide-react'
import { lazy, Suspense } from 'react'

const ActivityFeedCard = lazy(() => import('@/components/ui/activity-feed-card').then(mod => ({ default: mod.ActivityFeedCard })))

interface RecentActivityWidgetProps {
  title: string
  activities: any[]
  trackers: any[]
  statuses: any[]
  priorities: any[]
  users: any[]
  loading?: boolean
  compact?: boolean
}

export function RecentActivityWidget({
  title,
  activities,
  trackers,
  statuses,
  priorities,
  users,
  loading,
  compact = false
}: RecentActivityWidgetProps) {
  return (
    <Suspense fallback={<Card><CardContent className="p-6"><Skeleton className="h-64 w-full" /></CardContent></Card>}>
      <ActivityFeedCard
        title={title}
        icon={Activity}
        activities={activities}
        limit={5}
        showViewAll={true}
        viewAllLink="/activity"
        trackers={trackers}
        statuses={statuses}
        priorities={priorities}
        users={users}
        loading={loading}
        compact={compact}
      />
    </Suspense>
  )
}
